import React, {useEffect, useState} from 'react';
import AdminView from './adminView';
import {useNavigate} from "react-router-dom";
import  { login, getSecureToken } from '../loginUserAWS';
import { jwtDecode } from "jwt-decode";


const Admin: React.FC = () => {

    const navigate = useNavigate();
    const [verifyError, setVerifyError] = useState(false);


    const [nutzer, setNutzer] = useState<any>({
        username: '',
        password: ''
    })

    const einmelden = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const {name, value} =  e.target;
        setNutzer((antes: any) => ({
            ...antes, 
            [name]: value
        }))
    }


    const verify = async (e: React.FormEvent<HTMLFormElement>): Promise<Boolean> => {
       
        e.preventDefault();

        try {
            await login(nutzer.username, nutzer.password);
            const token = getSecureToken('idToken');
            if (token) {
                const decoded: any = await jwtDecode(token === null ? "" : token);
                if (decoded) {
                    const  groups: string = decoded['cognito:groups']; // Beispiel für einen Claim
                    const status = groups[0];
                    navigate("/", { state: { status } }); 
                    return true;
                } else {
                console.log("Token konnte nicht dekodiert werden.");
                return false;   
                }
            }
            else {
                console.log("Kein Token gefunden.");
                return false;
            }
        }
        catch(err) {
                console.log({message: "error by authentication", err})
                return false;
            }
    }
    
    const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        verify(event).then((result: Boolean) => {
            if (!result) {
                setVerifyError(true);
            }
        });
    };


    return <AdminView
     einmelden={einmelden}
     handleSubmit={handleSubmit}
     verifyError={verifyError}
     />
}




export default Admin;
